import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Building2, CircleDollarSign, CheckCircle2 } from 'lucide-react';

export const AboutSection = () => {
  const { language, t } = useLanguage();

  return (
    <section id="about" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[1.1fr_.9fr] gap-12 lg:gap-16 items-start">
          <div className={language === 'ar' ? 'text-right' : ''}>
            <span className="inline-block text-sm uppercase tracking-[0.14em] font-bold text-[#B78321] mb-4">{t.about.eyebrow}</span>
            <h2 className="text-3xl sm:text-5xl font-bold text-slate-900 leading-tight">{t.about.title}</h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-3xl">{t.about.body}</p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              <div className="rounded-2xl border border-slate-200 p-5 bg-slate-50">
                <Building2 className="w-7 h-7 text-[#0B4DA2] mb-3" />
                <p className="font-semibold text-slate-900">Ras Al Khaimah, UAE</p>
                <p className="text-sm text-slate-500 mt-1">Technology business incubation</p>
              </div>
              <div className="rounded-2xl border border-slate-200 p-5 bg-slate-50">
                <CheckCircle2 className="w-7 h-7 text-[#0B4DA2] mb-3" />
                <p className="font-semibold text-slate-900">{t.about.companies}</p>
                <p className="text-sm text-slate-500 mt-1">{t.about.program}</p>
              </div>
            </div>
          </div>

          <div id="program" className={`rounded-3xl border border-slate-200 bg-[#F8FAFC] p-7 sm:p-9 shadow-sm ${language === 'ar' ? 'text-right' : ''}`}>
            <span className="text-sm uppercase tracking-[0.12em] font-bold text-[#B78321]">{t.about.program}</span>
            <div className="mt-5 flex items-end gap-3">
              <div className="text-6xl font-extrabold text-[#0B4DA2] leading-none">10</div>
              <div className="pb-1 text-slate-600 font-medium">{t.about.companies}</div>
            </div>
            <div className="mt-6 flex items-start gap-4 rounded-2xl bg-white border border-slate-200 p-5">
              <CircleDollarSign className="w-8 h-8 text-[#D9A744] flex-shrink-0" />
              <div>
                <p className="font-bold text-slate-900">{t.about.funding}</p>
                <p className="mt-1 text-sm text-slate-500">{t.about.note}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
